import { APP_SETTINGS } from "src/environments/environment";

import { AfterContentInit, Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { AreaTecnica } from "src/app/models/area.tecnica.model";
import { CentroCusto } from "src/app/models/centrocusto.model";
import { EncarregadoCB } from "src/app/models/encarregadoCB.model";
import { Funcionario } from "src/app/models/funcionario.model";
import { TipoCheckList } from "src/app/models/tipoCheckList.model";
import { UsuarioAutorizacoes } from "src/app/models/usuario.autorizacoes.model";
import { AreaTecnicaService } from "src/app/pages/cadastros/areatecnica/areatecnica.service";
import { EmpreiteiraService } from "src/app/pages/cadastros/empreiteira/empreiteira.service";
import { FuncionarioService } from "src/app/pages/cadastros/funcionario/funcionario.service";
import { FabricantedeService } from "src/app/pages/cadastros/services/fabricante.service";
import { PTCheckList } from "src/app/pages/pt/models/PTCheckList.model";
import { CentroCustoService } from "src/app/services/centro.custo.service";
import { ClasseEquipamentoService } from "src/app/services/classe-equipamento.service";
import { EquipamentoService } from "src/app/services/equipamento.service";
import { GrupoLocalNivelService } from "src/app/services/grupo-local-nivel.service";
import { LocalService } from "src/app/services/local.service";
import { PrioridadeService } from "src/app/services/prioridade.service";
import { TipoCheckListService } from "src/app/services/tipochecklist.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { ImagemUtil } from "src/app/utils/Imagem.util";
import { Util } from "src/app/utils/util.util";
import Swal from "sweetalert2";
import { CommandResult } from "../../domain/commandResult";
import {
  ClasseEquipamento,
  GrupoLocalNivel1,
  Prioridade,
} from "../../domain/domain.model";
import {
  EquipamentoComboBoxViewModel,
  FotoBase64ViewModel,
} from "../../domain/viewmodels.models";
import { FecharOSService } from "../../os/fechar-os/fechar-os.service";
import { UploadPhoto } from "../../os/fechar-os/upload-photo.model";
import { Photo } from "../../os/fechar-os/photo.model";
import { PTService } from "../pt.service";
import { OSService } from "./../../../services/os-service";

@Component({
  selector: "app-cadastrar-pt",
  templateUrl: "./cadastrar-pt.component.html",
  styleUrls: ["./cadastrar-pt.component.scss"],
  providers: [
    CentroCustoService,
    LocalService,
    EquipamentoService,
    AreaTecnicaService,
    FuncionarioService,
    TipoCheckListService,
    EmpreiteiraService,
    FabricantedeService,
  ],
})
export class CadastrarPTComponent implements OnInit, AfterContentInit {
  constructor(
    private centroCustoService: CentroCustoService,
    private toastr: ToastrService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private localService: LocalService,
    private equipamentoService: EquipamentoService,
    private areaTecnicaService: AreaTecnicaService,
    private funcionarioService: FuncionarioService,
    private tipoCheckListService: TipoCheckListService,
    private modalService: NgbModal,
    private ptService: PTService,
    private empreiteiraService: EmpreiteiraService,
    private fabricanteService: FabricantedeService,
    private usuarioService: UsuarioService,
    private grupoLocalNivelService: GrupoLocalNivelService,
    private classeEquipamentoService: ClasseEquipamentoService,
    private prioridadeService: PrioridadeService,
    private formBuilder: FormBuilder,
    private fechamentoOSService: FecharOSService,
    private osService: OSService
  ) {}

  

  centrosDeCusto: CentroCusto[] = [];
  isNovoCadastro = true;
  isSalvando = false;

  equipamentos: EquipamentoComboBoxViewModel[] = [];
  areasTecnicas: AreaTecnica[] = [];
  encarregados: EncarregadoCB[] = [];

  pTsCheckList: PTCheckList[] = [];
  tiposCheckLists: TipoCheckList[] = [];

  funcionarios: Funcionario[] = [];
  funcionariosSelecionados: Funcionario[] = [];

  engenheiros: Funcionario[] = [];
  empreiteiras: any[] = [];
  fabricantes: any[] = [];

  form: FormGroup = null;
  formEquipamento: FormGroup = null;
  formFabricante: FormGroup = null;
  formAreaTecnica: FormGroup = null;
  formLocal: FormGroup = null;

  buscandoEquipamentos = false;
  autorizacoes: UsuarioAutorizacoes;

  public niveis1: GrupoLocalNivel1[] = [];
  public locaisPorNivel: any[] = [];
  public classesEquipamento: ClasseEquipamento[] = [];

  prioridades: Prioridade[] = [];

  autorizacaoAdicionarFoto: boolean;
  files: File[] = []; // armazena os arquivo de fotos
  previewsPhotos: Photo[] = []; // armazena as photos em base 64 para exibição
  previewPhotoSelecionada: Photo; // dataUrl (base 64) da foto clicada
  photoForm: FormGroup;
  isLoadingRegistroFotografico: boolean = false;
  uploadPhotos: UploadPhoto[] = [];
  isRemoveProcessing: boolean;
  requeridoRamalCentroCusto: boolean = APP_SETTINGS.requeridoRamalCentroCusto;
  contatoValid: boolean = true;
  centroCustoValid: boolean = true;
  labelCentroCusto: string = APP_SETTINGS.LabelCentroCusto;

  tipoOSFixas: any[] = [];
  tipoOSAdicionais: any[] = [];


  ngAfterContentInit(): void {
    this.autorizacoes =
      this.usuarioService.getAutorizacoesJanelaPorRota("solicitar-pt");
    this.autorizacaoAdicionarFoto =
      this.usuarioService.getAutorizacoesEspecificaPorRota(
        "ss-pt-programar-servico",
        "adicionar-fotos-antes"
      );
  }
  

  
  resetForm() {
    this.form = this.formBuilder.group({
      requisitante: [null, Validators.required],
      contato: ["", [Validators.maxLength(7)]],
      servico: [null, Validators.required],
      centroCustoId: [""],
      id: [""],
      areaRestrita: [null, Validators.required],
      empreiteiraId: ["", Validators.required],
      prioridadeId: ["", Validators.required],
      tipoOS: ["", Validators.required],
      areaTecnicaId: ["", Validators.required],
      localId: ["", Validators.required],
      equipamentoId: [""],
      spvId: [0],
      grupoLocalNivel1Id: [""],
      datalistCentroCustos: [""],
      uploadPhotos: [], // caso precise enviar pelo form
    });

    this.locaisPorNivel = [];
    this.contatoValid = true;
    this.centroCustoValid = true;

    if (this.empreiteiras) {
      if (this.empreiteiras.length == 1) {
        this.form.get("empreiteiraId").setValue(this.empreiteiras[0].id);
      }
    }
  }

  resetFormEquipamento() {
    this.formEquipamento = new FormGroup({
      id: new FormControl(0),
      nome: new FormControl(null, Validators.required),
      numeroSerie: new FormControl(null, Validators.required),
      descricao: new FormControl(null, Validators.required),
      localId: new FormControl("", Validators.required),
      tipoEquipamentoId: new FormControl(1, Validators.required),
      fabricanteId: new FormControl("", Validators.required),
      classeEquipamentoId: new FormControl("", Validators.required),
    });
  }

  resetFormFabricante() {
    this.formFabricante = new FormGroup({
      id: new FormControl(0),
      nome: new FormControl(null, Validators.required),
    });
  }

  resetFormAreaTecnica() {
    this.formAreaTecnica = new FormGroup({
      id: new FormControl(0),
      nome: new FormControl(null, Validators.required),
    });
  }

  resetFormLocal() {
    this.formLocal = new FormGroup({
      id: new FormControl(0),
      nome: new FormControl(null, Validators.required),
    });
  }

  resetPhotoForm() {
    this.photoForm = this.formBuilder.group({
      photo: ["", [Validators.required]],
    });
  }

  ngOnInit() {
    this.resetForm();
    this.resetPhotoForm();
    this.resetFormEquipamento();
    this.resetFormAreaTecnica();
    this.resetFormLocal();
    this.getFabricantes();
    this.getAllGrupoLocalNivel1();
    this.getClassesEquipamentos();
    this.getPrioridades();
    this.getTiposOSs();
    //this.localService.getLocaisNaoPredio().subscribe((response) => { this.locaisPorNivel = response; });
    this.areaTecnicaService.getAreasTecnicas().subscribe(
      (response) => {
        this.areasTecnicas = response;
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter Areas Técnicas");
      }
    );

    this.tipoCheckListService
      .getTiposCheckListComCheckLists()
      .subscribe((response) => {
        this.tiposCheckLists = response;
      });

    this.centroCustoService.getCentrosCustos().subscribe(
      (response: CentroCusto[]) => {
        this.centrosDeCusto = response;
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter lista de Centros Custos");
      }
    );

    this.equipamentos = [];

    const param = this.activatedRouter.snapshot.params.id;
    this.isNovoCadastro = param === undefined || param === "";

    if (!this.isNovoCadastro) {
      this.getPT(Number(param));
    } else {
      this.empreiteiraService.getEmpreiteiras().subscribe((response) => {
        this.empreiteiras = response;

        if (this.empreiteiras.length == 1) {
          this.form.get("empreiteiraId").setValue(this.empreiteiras[0].id);
        }
      });
    }
    document.getElementById("requisitante").focus();
  }

  getTiposOSs() {
    this.osService.GetTiposOSs().subscribe((response: any[]) => {
      if (response) {
        this.tipoOSFixas = response.filter(x => x.tipo === 'F');
        this.tipoOSAdicionais = response.filter(x => x.tipo === 'A');
      }
    })
    }

  getPrioridades() {
    this.prioridadeService.getAll().subscribe((response: Prioridade[]) => {
      this.prioridades = response;
    });
  }

  getAllGrupoLocalNivel1() {
    this.grupoLocalNivelService
      .getAllGrupoLocalNivel1()
      .subscribe((response: GrupoLocalNivel1[]) => {
        this.niveis1 = response;

        if (this.niveis1.length === 1) {
          this.form.get("grupoLocalNivel1Id").setValue(this.niveis1[0].id);
          this.changeGrupoLocalNivel1(this.niveis1[0].id);
        } else {
          this.form.get("grupoLocalNivel1Id").setValue("");
          this.locaisPorNivel = [];
          this.equipamentos = [];
        }
      });
  }

  changeGrupoLocalNivel1(localId = null) {
    this.locaisPorNivel = [];
    this.equipamentos = [];

    const grupoLocalNivel1Id = Number(
      this.form.get("grupoLocalNivel1Id").value
    );

    if (grupoLocalNivel1Id > 0) {
      this.localService
        .getLocaisByGroupLevelOne(grupoLocalNivel1Id)
        .subscribe((response) => {
          this.locaisPorNivel = response;

          if (localId != null) {
            if (this.locaisPorNivel.length == 1) {
              this.form.get("localId").setValue(this.locaisPorNivel[0].id);
              this.getEquipamentoPorLocalId(this.locaisPorNivel[0].id);
            } else {
              this.form.get("localId").setValue("");
            }
          } else {
            this.form.get("localId").setValue("");
          }
        });
    }
  }

  private getClassesEquipamentos() {
    this.classeEquipamentoService
      .getAll()
      .subscribe((response: ClasseEquipamento[]) => {
        this.classesEquipamento = response;
      });
  }

  getFabricantes() {
    this.fabricanteService.list().subscribe((response: any) => {
      this.fabricantes = response;
    });
  }

  getEquipamentoPorLocalId(
    localId: number,
    equipamentoId: undefined = undefined
  ) {
    if (Number(localId) === 0) {
      this.equipamentos = [];
      return;
    }

    this.buscandoEquipamentos = true;
    this.equipamentoService.getEquipamentosPorLocalId(localId).subscribe(
      (response) => {
        this.equipamentos = response;
        this.buscandoEquipamentos = false;
        if (equipamentoId !== undefined) {
          this.form.get("equipamentoId").setValue(equipamentoId);
          this.form.get("localId").setValue(localId);
        }
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter Equipamentos");
        this.buscandoEquipamentos = false;
      }
    );
  }

  submit() {
    if (this.validForm()) {
      this.modalService.dismissAll();
      this.isSalvando = true;

      if (this.isNovoCadastro) {
        this.form.get("id").setValue(0);
      }

      let count = 0;

      this.uploadPhotos = [];
      if (this.files.length > 0) {
        for (const f of this.files) {
          count++;
          this.uploadPhotos.push({
            id: 0,
            arquivoNomeOriginal: f.name,
            arquivoNome: Util.getArquivoNome(this.form.get("id").value, count),
            osFechamentoId: null,
            spvId: 0,
            atividadeId: null,
          });
        }
      }

      const spv = {
        requisitante: this.form.controls.requisitante.value,
        contato: this.form.controls.contato.value,
        servico: String(this.form.controls.servico.value).toUpperCase(),
        centroCustoId: this.form.controls.centroCustoId.value,
        status: 2,
        tipoSPV: 2,
        spvId: this.form.controls.centroCustoId.value,
        uploadPhotos: this.uploadPhotos,
      };

      this.form.removeControl("requisitante");
      this.form.removeControl("contato");
      this.form.removeControl("servico");
      this.form.removeControl("centroCustoId");

      this.form.addControl("spv", new FormControl(null));
      this.form.controls.spv.setValue(spv);

      this.ptService.save(this.form.value).subscribe(
        (response: CommandResult) => {
          if (response.success === true) {
            this.toastr.success(response.message);

            if (this.files.length > 0) {
              this.fechamentoOSService
                .uploadPhotos(this.files, this.uploadPhotos)
                .subscribe(
                  () => {
                    this.reset();
                  },
                  (exception: any) => {
                    this.showErrorExecption(exception);
                  }
                );
            } else {
              this.reset();
            }
          } else {
            this.toastr.error(response.message);
          }

          this.isSalvando = false;
        },
        (exception: any) => {
          this.showErrorExecption(exception);
          this.isSalvando = false;
        },
        () => (this.isSalvando = false)
      );
    }
  }

  validForm() {
    let isFormValid: boolean = true;
    this.contatoValid = true;
    this.centroCustoValid = true;

    const dadosForm = this.form.value;

    if (this.requeridoRamalCentroCusto) {
      if (dadosForm.contato == "") {
        this.contatoValid = false;
        isFormValid = false;
      }

      if (dadosForm.centroCustoId == "") {
        this.centroCustoValid = false;
        isFormValid = false;
      }
    }

    if (
      dadosForm.requisitante == "" ||
      dadosForm.servico == "" ||
      dadosForm.areaRestrita == null ||
      dadosForm.empreiteiraId == "" ||
      dadosForm.prioridadeId == "" ||
      dadosForm.tipoOS == "" ||
      dadosForm.areaTecnicaId == "" ||
      dadosForm.localId == ""
    ) {
      isFormValid = false;
    }

    if (!isFormValid) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.toastr.error("Um ou mais campos obrigatórios não foram informados");
    }

    return isFormValid;
  }

  changeRamal(value) {
    if (this.requeridoRamalCentroCusto) {
      this.contatoValid = value != "";
    }
  }

  changeCentroCusto(value) {
    if (this.requeridoRamalCentroCusto) {
      this.centroCustoValid = value != "";
    }
  }

  reset() {
    this.resetForm();
    this.resetFormEquipamento();
    this.resetFormAreaTecnica();
    this.resetFormLocal();
    this.getFabricantes();

    this.isSalvando = false;
    this.isNovoCadastro = true;

    this.pTsCheckList = [];
    this.equipamentos = [];

    // recria os campos removidos do Spv a submeter o formulário
    this.form.addControl("requisitante", new FormControl(null));
    this.form.addControl("contato", new FormControl(null));
    this.form.addControl("servico", new FormControl(null));
    this.form.addControl("centroCustoId", new FormControl(null));

    // remove os campos adicionados ao remover o formulário
    this.form.removeControl("spv");
    this.form.removeControl("pTsCheckList");
    this.form.removeControl("colaboradores");

    this.router.navigate(["solicitar-pt/cadastrar"]);

    document.getElementById("requisitante").focus();

    this.files = [];
    this.resetPhotoForm();
    this.previewsPhotos = [];
    this.previewPhotoSelecionada = null;
    this.uploadPhotos = [];

    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  /* *** Obtenção de PT para edição *** */

  getPT(id: number): void {
    this.previewsPhotos = [];
    this.previewPhotoSelecionada = null;
    this.files = [];
    this.isLoadingRegistroFotografico = true;

    this.ptService.getPTComColecoesFilhas(id).subscribe(
      (response: any) => {
        this.form.patchValue({
          requisitante: response.spv.requisitante,
          contato: response.spv.contato,
          servico: response.spv.servico,
          centroCustoId:
            response.spv.centroCustoId == null
              ? ""
              : response.spv.centroCustoId,
          id: response.id,
          areaRestrita: response.areaRestrita,
          empreiteiraId: response.empreiteiraId,
          observacoesGerais: response.observacoesGerais,
          prioridadeId: response.prioridadeId,
          tipoOS: response.tipoOS,
          areaTecnicaId: response.areaTecnicaId,
          grupoLocalNivel1Id: response.local.grupoLocalNivel1Id,
          uploadPhotos: [],
          datalistCentroCustos: response.spv.centroCusto.nome,
          spvId: response.spvId,
        });

        this.changeGrupoLocalNivel1(response.local.id);

        //this.form.controls.datalistCentroCustos.setValue(response.spv.centroCusto.nome);
        //this.form.controls.spvId.setValue(response.spvId);

        this.uploadPhotos = response.spv.uploadPhotos;

        this.fechamentoOSService
          .getArrayFotosBase64(this.uploadPhotos)
          .subscribe((responseFotos: FotoBase64ViewModel[]) => {
            responseFotos.forEach((foto) => {
              this.handleFile(
                [].concat(
                  Util.dataURLtoFile(foto.base64String, foto.arquivoNome)
                ),
                false
              );
              this.previewsPhotos.push({
                dataUrl: foto.base64String,
                name: foto.arquivoNome,
              });
            });
            this.isLoadingRegistroFotografico = false;
          });
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter o PT");
      }
    );
  }

  openModalNovaAreaTecnica(modal) {
    this.resetFormAreaTecnica();
    this.modalService.open(modal, { windowClass: "sm", backdrop: "static" });
  }

  openModalCadastroEquipamento(localId: string, modal: any) {
    if (Number(localId) === 0) {
      this.toastr.warning(
        "<b>Local de Trabalho</b><br />deve ser informado antes do cadastro um <b>Equipamento</b>"
      );
      this.form.get("localId").setErrors({ invalidLocalId: true });
      return;
    }

    this.resetFormEquipamento();

    this.formEquipamento.get("localId").setValue(localId);

    this.modalService.open(modal, {
      windowClass: "lgModal",
      backdrop: "static",
    });
  }

  openModalCadastroFabricante(modal: any) {
    this.resetFormFabricante();
    this.modalService.open(modal, {
      windowClass: "smModal",
      backdrop: "static",
    });
  }

  novaAreaTecnica(c: any) {
    this.areaTecnicaService
      .isUniqueNomeAreaTecnica(this.formAreaTecnica.get("nome").value)
      .subscribe((isUniqueNomeAreaTecnica) => {
        if (isUniqueNomeAreaTecnica) {
          this.areaTecnicaService
            .setOutraAreaTecnica({
              nome: this.formAreaTecnica.get("nome").value,
            })
            .subscribe((objOutraareatecnica) => {
              if (Number(objOutraareatecnica.id) > 0) {
                this.areaTecnicaService.getAreasTecnicas().subscribe(
                  (response) => {
                    this.areasTecnicas = response;
                    this.toastr.success("Área Técnica cadastrada com sucesso");
                    this.form
                      .get("areaTecnicaId")
                      .setValue(Number(objOutraareatecnica.id));
                    c("Close click");
                  },
                  (err: any) => {
                    this.toastr.error("Erro ao tentar obter Areas Técnicas");
                  }
                );
              }
            });
        } else {
          this.formAreaTecnica.get("nome").setErrors({ notUnique: true });
        }
      });
  }

  exibirDetalhesCentroCusto(centroCustoId: any) {
    // Todo: conluir
    if (Number(centroCustoId) > 0) {
      console.log(centroCustoId);
    }
  }

  addEquipamento(c) {
    this.equipamentoService
      .nomeJaCadastrado(this.formEquipamento.get("nome").value)
      .subscribe((isUniqueNomeEquipamento) => {
        if (isUniqueNomeEquipamento) {
          this.equipamentoService
            .numeroSerieJaCadastrada(
              this.formEquipamento.get("numeroSerie").value
            )
            .subscribe((isUniqueNumeroSerieEquipamento) => {
              if (isUniqueNumeroSerieEquipamento) {
                this.equipamentoService
                  .post(this.formEquipamento.value)
                  .subscribe(
                    (retorno: any) => {
                      const id = retorno.data;

                      this.equipamentoService
                        .getEquipamentosPorLocalId(
                          this.formEquipamento.get("localId").value
                        )
                        .subscribe(
                          (response: any) => {
                            this.equipamentos = response;
                            this.form.get("equipamentoId").setValue(Number(id));
                            c("Close click");
                            this.toastr.success(retorno.message);
                          },
                          (err: any) => {
                            if (err.error.errors) {
                              this.toastr.error(err.error.errors[0].message);
                            } else {
                              this.toastr.error("Ocorreu um erro no servidor");
                            }
                          }
                        );
                    },
                    (err: any) => {
                      if (err.error.errors) {
                        this.toastr.error(err.error.errors[0].message);
                      } else {
                        this.toastr.error("Ocorreu um erro no servidor");
                      }
                    }
                  );
              } else {
                this.formEquipamento
                  .get("numeroSerie")
                  .setErrors({ notUniquens: true });
              }
            });
        } else {
          this.formEquipamento.get("nome").setErrors({ notUnique: true });
        }
      });
  }

  addFabricante(c) {
    this.fabricanteService
      .isUniqueNomeFabricante(this.formFabricante.get("nome").value)
      .subscribe((isUniqueNomeFabricante) => {
        if (isUniqueNomeFabricante) {
          this.fabricanteService.create(this.formFabricante.value).subscribe(
            (retorno: any) => {
              const id = retorno.data;

              this.fabricanteService.list().subscribe(
                (response: any) => {
                  this.fabricantes = response;
                  this.formEquipamento.get("fabricanteId").setValue(Number(id));
                  c("Close click");
                  this.toastr.success(retorno.message);
                },
                (err: any) => {
                  if (err.error.errors) {
                    this.toastr.error(err.error.errors[0].message);
                  } else {
                    this.toastr.error("Ocorreu um erro no servidor");
                  }
                }
              );
            },
            (err: any) => {
              if (err.error.errors) {
                this.toastr.error(err.error.errors[0].message);
              } else {
                this.toastr.error("Ocorreu um erro no servidor");
              }
            }
          );
        } else {
          this.formFabricante.get("nome").setErrors({ notUnique: true });
        }
      });
  }

  limparDataListCentroCustos() {
    this.form.get("datalistCentroCustos").setValue("");
  }

  changeDataListCentroCustos(value: string) {
    let item;
    if (value != "") {
      item = this.centrosDeCusto.filter((t) =>
        t.nome.toLowerCase().includes(value.toLowerCase())
      )[0];
    }
    if (item != undefined) {
      this.form.get("datalistCentroCustos").setValue(item.nome);
      this.form.get("centroCustoId").setValue(item.id);
    } else {
      this.form.get("datalistCentroCustos").setValue("");
      this.form.get("centroCustoId").setValue("");
    }
  }

  openModalExibePhoto(modal, pview) {
    this.previewPhotoSelecionada = pview;
    this.modalService.open(modal, {
      windowClass: "zoomPhotoModal",
      backdrop: "static",
    });
  }

  handleFile(files: File[], addPreviewsPhotos: boolean = true) {
    ImagemUtil.handleFile(
      files,
      this.files,
      this.previewsPhotos,
      this.isLoadingRegistroFotografico,
      addPreviewsPhotos
    );
    this.photoForm.get("photo").setValue("");
  }

  removerPhoto(name: string) {
    let jaPersistido: boolean = false;
    const uploadPhoto = this.uploadPhotos.find((t) => t.arquivoNome == name);
    if (uploadPhoto != undefined) {
      jaPersistido = uploadPhoto.id > 0;
    }
    if (jaPersistido == false) {
      this.previewsPhotos = this.previewsPhotos.filter(
        (photo: Photo) => photo.name !== name
      );
      this.files = this.files.filter((f) => f.name !== name);
    } else {
      this.removerPhotoPersistida(name, uploadPhoto.id);
    }
  }
  public removerPhotoPersistida(name: string, osFechamentoId: number) {
    Swal({
      title: "Excluir",
      text: "Deseja remover o registro fotográfico selecionado?",
      type: "question",
      showCancelButton: true,
      cancelButtonText: "Não",
      showConfirmButton: true,
      confirmButtonText: "Sim",
      cancelButtonColor: "#d33",
      focusCancel: true,
    }).then((result) => {
      if (result.value) {
        this.delete(name, osFechamentoId);
      }
    });
  }
  private delete(name: string, osFechamentoId: number): void {
    this.isRemoveProcessing = true;
    this.osService.removerUploadPhoto(osFechamentoId).subscribe(
      (response: CommandResult) => {
        const cmdResult = new CommandResult(
          response.success,
          response.message,
          response.notifications,
          response.data
        );
        if (cmdResult.success === true) {
          this.toastr.success(cmdResult.message);
          this.previewsPhotos = this.previewsPhotos.filter(
            (photo: Photo) => photo.name !== name
          );
          this.files = this.files.filter((f) => f.name !== name);
        } else {
          this.toastr.warning(cmdResult.message);
        }
        this.isRemoveProcessing = false;
      },
      (exception: any) => {
        const cmdResult = new CommandResult(false, "", [], null);
        cmdResult.showErrorExecption(exception);
        this.isRemoveProcessing = false;
      },
      () => (this.isRemoveProcessing = false)
    );
  }

  private showErrorExecption(exception: any) {
    let msg = exception.message;
    if (Number(exception.status) === 0) {
      msg = "A aplicação não conseguiu se conectar ao Servidor";
    }
    if (Number(exception.status) === 500) {
      msg = "O Servidor gerou um erro de processamento";
    }
    this.toastr.error(
      `<b>Erro no Servidor</b><br /><br />status: <b>${exception.status}</b><br /><br />${msg}`
    );
  }

  changeEmpreiteira(empreiteiraId) {
    console.log(empreiteiraId);
  }
}
